import { Form, useFormikContext } from "formik";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Button, FormInput } from "../atoms";
import { ShopCartType } from "./ShopTypes";

type FormValues = {
  priceOverride: number;
};

type ShopGiftVoucherProps = {
  setCart: (value: ShopCartType, stayInSection?: boolean) => void;
};

const presetValues = [20, 50, 100, 150];

const ShopGiftVoucher = ({ setCart }: ShopGiftVoucherProps) => {
  const formik = useFormikContext<FormValues>();
  const {
    values: { priceOverride },
    setFieldValue,
  } = formik;

  const { t } = useTranslation();
  useEffect(() => {
    if (priceOverride === undefined) {
      setFieldValue("priceOverride", 10);
    }
    const newCart: ShopCartType = {
      type: "GIFT_VOUCHER",
      payload: {
        amount: priceOverride,
        name: t("page.hostedPagesVoucherCheckout.name"),
      },
    };

    setCart(newCart, true);
  }, [priceOverride, setCart, t, setFieldValue]);

  return (
    <div className="flex max-w-[26rem] flex-col items-start gap-5 p-6">
      <Form className="flex h-full grow flex-col items-center gap-6">
        <div className="flex flex-col items-start">
          <div className="text-base font-semibold">
            {t("components.shop.giftVoucher.title")}
          </div>
          <div className="text-sm">
            {t("components.shop.giftVoucher.description")}
          </div>
        </div>
        <div className="flex w-full flex-col gap-4">
          <FormInput
            type="number"
            name="priceOverride"
            placeholder={t("page.hostedPagesVoucherCheckout.placeholder")}
          />
          <div className="flex flex-row flex-wrap gap-2">
            {presetValues.map((val) => (
              <Button
                key={val}
                intent={
                  formik.values.priceOverride === val ? "secondary-light-outline" : "default" 
                }
                className="w-16 !rounded-full"
                type="button"
                onClick={() => {
                  formik.setFieldValue("priceOverride", val);
                  const newCart: ShopCartType = {
                    type: "GIFT_VOUCHER",
                    payload: {
                      amount: val,
                      name: t("page.hostedPagesVoucherCheckout.name"),
                    },
                  };
                  setCart(newCart);
                }}
              >
                {val}
              </Button>
            ))}
          </div>
        </div>
      </Form>
    </div>
  );
};

export default ShopGiftVoucher;
